define(function(require) {
    var $ = require('j');
    var device = require('util/device.util');
    var _ = require('underscore');

    require('widgets/accordion.widget');

    return $.widget('accordion', 'accordion', {

        init: function(options) {
            _.extend(this.options, options);

            this.on(this.$el, {
                'tap .fn-accordion-target': this.handleToggleList,
                'tapHover .fn-accordion-target': this.manageHoverClass.bind(this, 'add'),
                'tapRemoveHover .fn-accordion-target': this.manageHoverClass.bind(this, 'remove')
            }, this);
        },

        handleToggleList: function(e) {
            var accordionBody = e.currentTarget.parentNode.querySelector('.fn-accordion-body');

            this.toggleList(e);// core native fn
            this.setWindowH();

            if(this.isScroll(accordionBody)) {
                window.scrollBy(0, this.getScrollY(accordionBody));
            }
        },

        isScroll: function(el) {
            var topEl = el.getBoundingClientRect().top;

            return this.currentWindowH - topEl * 1.05 <= 0; // 105%
        },

        getScrollY: function(el) {
            var bottomEl = el.getBoundingClientRect().bottom;

            return Math.abs(bottomEl - this.currentWindowH) * this.isTooHighlyBody(el);
        },

        isTooHighlyBody: function(el) {
            var heightEl = el.getBoundingClientRect().height;

            return heightEl > this.currentWindowH * 0.7 ? 0.5 : 1;//70% window height
        },

        setWindowH: function() {
            this.currentWindowH = window.innerHeight || window.outerHeight * device.pixelRatio;
        }
    });
});
